import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useEffect } from "react";
//import { useParams } from "react-router-dom";

interface ParentProps  {
  intPage : number;
  intPageSize : number;
  totalPageCount : number;
  startPage : number;
  setIntPage: Dispatch<SetStateAction<number>>
}

const Pagination = ({intPage, intPageSize, totalPageCount, startPage, setIntPage}: ParentProps ) => {
  //const param = useParams();
  
  const arrayPage: number[] = Array.from({ length: intPageSize }, (_, i) => startPage + i).filter(page => page <= totalPageCount);

  useEffect(() => {
    
  }, []);

  return (
    <>
      <div>
        <div className={`paginationStyle flex-justfy-content-center align-items-center ${(totalPageCount === 0) ? "dp_none" : "flex"}`}>
          <div className={`pagingArea align-items-center ${(startPage <= 1) ? "dp_none" : "flex"}`} onClick={() => setIntPage(startPage - 1)}>
            <span className={`pagingNumber`} ><FontAwesomeIcon icon={faAngleLeft} /></span>
          </div>
          {
            arrayPage?.map((value:number, index: number) => (
              <div key={value} className='pagingArea flex align-items-center' onClick={() => setIntPage(value)}>
                <span className={`pagingNumber ${intPage === value ? "on" : ""}`} >{value}</span>
              </div>
            ))
          }
          <div className={`pagingArea align-items-center ${((startPage + arrayPage.length -1) >= totalPageCount) ? "dp_none" : "flex"}`} onClick={() => setIntPage(startPage + arrayPage.length)}>
            <span className={`pagingNumber`} ><FontAwesomeIcon icon={faAngleRight} /></span>
          </div>
        </div>
      </div>
    </>
  );
}
export default Pagination;